<template>
  <div style="margin:20px">

    <div style="width: 100%; background-color: #eee; border: 1px dotted grey; margin-bottom: 25px;">
      <span style="font-size: 26px; font-weight: bold">Planned - Vehicle Utilization Weekly</span><br/>
      <span style="font-style: italic; font-size: 18px">this view shows the vehicles scheduled by date over the next week, click the vehicle to see more details</span>
    </div>

    <div style="position: relative; font-size: 20px; font-weight: bold; " class="align-right d-flex align-items-center justify-content-center">
      <a href="#" class="arrows" v-on:click.prevent="shift_detail_graph_date(-1)"><</a>
      &nbsp;&nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_fromDate" :config="options" :placeholder="details_fromDate"></date-picker>&nbsp;&nbsp;
      <a href="#" class="arrows" v-on:click.prevent="shift_detail_graph_date(1)">></a>
      <span v-if="base_options && base_options.length > 2">
        &nbsp;&nbsp;&nbsp;Yard:&nbsp;<b-form-select v-model="selected_base" :options="base_options" style="font-size: 20px; font-weight: bold; width:200px"/>
      </span>
      <span v-if="vehicle_tag_options && vehicle_tag_options.length > 2">
        &nbsp;&nbsp;&nbsp;Tag:&nbsp;<b-form-select v-model="selected_vehicle_tag" :options="vehicle_tag_options" style="font-size: 20px; font-weight: bold; width:250px"/>
      </span>
      &nbsp;&nbsp;|&nbsp;&nbsp;Overnight Offset: &nbsp;<b-form-select v-model="selected_hours_offset" :options="hours_offset_options" style="font-size: 18px; font-weight: bold; width:100px"/>
      &nbsp;&nbsp;<b-button v-on:click.prevent="load_data()">Search</b-button>
    </div>
    <br/>
    <div v-if="!loading">
      <div class="row" style="margin:10px; font-weight: bold; font-size: 20px;">
        <template v-for="type_stat in summary.vehicle_type_stats">
          <div @click="filter_by_type(type_stat.type)" class="col" :style="{ 'background': type_stat.color }">{{type_stat.type}}</div>
        </template>
      </div>
      <br/>
      <div class="align-right d-flex justify-content-center" style='display: flex; flex-wrap: nowrap'>
        <div  style="max-width: 250px; min-width: 250px !important; border: 1px solid black; margin-top:5px" v-for="(day_record,day_idx) in items">
          <div style="background-color: #eee; border-bottom: 2px solid black;font-weight: bold; font-size:22px; text-align:center">{{day_record.date_month}}/{{day_record.date_day}} - {{day_record.date_weekday}}</div>
          <template v-if="!selected_type || selected_type==vehicle.vehicle_type" v-for="vehicle in day_record.vehicles">
            <div style="text-align: center; margin: 2px; padding: 4px;" :style='getStyleForVehicleID(vehicle.colorcode)' v-on:click="toggle_div(vehicle.vehicleID)"><b>{{vehicle.vehicleID | trim(20)}}</b></div>
            <div :style="vehicle_expanded == vehicle.vehicleID ? 'text-align: left;min-height: 120px; border: 1px dotted darkgrey; margin: 8px; padding: 2px;' : 'display:none'">
              <span v-for="item in vehicle.movements">
                  <div style="padding: 5px !important; margin: 3px !important; padding: 0px !important">
                    <div v-if="item.charterID">
                      &nbsp;&nbsp;<b>BookingID:</b> {{item.bookingID}}<br/>
                      &nbsp;&nbsp;<b>Start:</b> {{item.start_datetime | formatDateTimeSmall}}<br/>
                      &nbsp;&nbsp;<b>Finish:</b> {{item.finish_datetime | formatDateTimeSmall}}
                    </div>
                  </div>
                </span>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div v-else>
      <br/><br/>
      <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
    </div>

  </div>

</template>
<script>
import {get_tag_list, get_vehicle_calendar, get_yard_list} from '../networking/apis'
import {mapState} from "vuex"
import {justDate} from '../helpers/dates'
import moment from 'moment'

export default {
  name: 'planned_vehicle_weekly',

  components: {
  },

  data() {
    return {
      items: [],
      summary: [],
      loading: false,
      details_fromDate: justDate(moment()),
      selected_type: null,
      vehicle_expanded: null,
      selected_base: '',
      selected_vehicle_tag: '',
      base_options: [],
      vehicle_tag_options: [],
      selected_hours_offset: '',
      hours_offset_options: [
        { value: '0', text: 'None' },
        { value: '1', text: '1AM' },
        { value: '2', text: '2AM' },
        { value: '3', text: '3AM' },
        { value: '4', text: '4AM' },
        { value: '5', text: '5AM' },
        { value: '6', text: '6AM' },
      ],
      options: {
        format: 'MM-DD-YYYY',
        useCurrent: true,
        minDate: moment().subtract(90, 'days'),
        maxDate: moment().add(90, 'days'),
        keepOpen: false,
        showClear: true,
        showClose: true,
      },
    }
  },
  async created() {
    this.check_features()
  },
  methods: {
    async check_features() {
      this.load_bases()
      this.load_tags()
      this.load_data()
    },
    async load_bases() {
      const {value: {data = []}} = await get_yard_list(this.user.tenant)
      this.base_options = data
    },
    async load_tags() {
      const {value: {data = []}} = await get_tag_list(this.user.tenant)
      this.vehicle_tag_options = data
    },
    toggle_div(item,field) {
      if (this.vehicle_expanded == item)
          this.vehicle_expanded = null;
      else
          this.vehicle_expanded = item;
      this.$forceUpdate();
    },
    filter_by_type(type) {
      if (type == null || this.selected_type == type) {
        this.selected_type = null
      } else {
        this.selected_type = type
      }
    },
    async load_data() {

      this.loading = true
      try {
        console.log('base:' + this.selected_base + ', tag:' + this.selected_tag)
        const { value: { data = [] }} = await get_vehicle_calendar(this.user.tenant, this.selected_hours_offset, moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),this.selected_base,this.selected_vehicle_tag)
        this.summary = data.summary
        moment.tz.setDefault(this.summary.timezone)
        this.items = data.results
        this.selected_hours_offset = this.summary.hours_offset
      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }

      this.loading = false
    },
    getStyleForVehicleID(color) {
      if (color != null)
        return 'border-radius: 10px; background-color:' + color
      return '';
    },
    async shift_detail_graph_date(shift) {
      this.details_fromDate = moment(this.details_fromDate, 'MM-DD-YYYY').add(shift, 'days').format('MM-DD-YYYY');
    }
  },
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.check_features()
      }
    },
    selected_vehicle_tag() {
      if (this.selected_vehicle_tag != '')
        this.selected_base = ''
    },
    selected_base() {
      if (this.selected_base != '')
        this.selected_vehicle_tag = ''
    },
    details_fromDate(target_from_date) {
      this.details_fromDate = target_from_date
      this.details_toDate = justDate(moment(target_from_date,'MM-DD-YYYY').add(27, 'days'));
      this.load_data();
    }
  }
}
</script>

<style>
.arrows {font-size: 22px; font-weight: bold; color: var(--fi-rail-accent) !important }
</style>
